import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { EnvironmentService } from './environment.service';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { DynamicControl } from '../models/charts';

@Injectable({
  providedIn: 'root'
})
export class ChartsService{

  constructor(private http: HttpClient, private authenticationService: AuthenticationService, private env: EnvironmentService) { }

  getAllCharts(depName, days, granularity, userName: string = "all"){
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName +'/GetData/Days=' + days;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
    .set('depName', depName)
      .set('Granularity', granularity)
      //.set('checkUserDepAccess', depName)
    return this.http.get(baseUrl, { headers: headers });
  }

  getSpecificChart(depName, chartName, days, granularity, userName: string = "all"){
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName +'/GetData/' + chartName + '/Days=' + days
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
    .set('depName', depName)
    .set('Granularity', granularity).set('checkUserDepAccess', depName)
    .set('UserName', userName)
    return this.http.get(baseUrl, { headers: headers });
  }

  getGranularity(){
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/GetGranularity'
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
    return this.http.get(baseUrl, { headers: headers });
  }

  getCustomDateData(depName, chartName, startDate, endDate){
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName +'/GetData/' + chartName + '/StartDate=' + startDate + '/EndDate=' + endDate
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
    .set('depName', depName).set('checkUserDepAccess', depName)
    return this.http.get(baseUrl, { headers: headers });
  }

  getNodeUsage(depName, chartName, days, granularity, userName: string = "all", wsName: string, nodeWise: boolean, nodeGroup: string, type?: string) {
    let nodeUsageType;
    if (!type && type == null) {
      nodeUsageType = "all";
    }
    else {
      nodeUsageType = type;
    }
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/GetData/NodeWise/' + nodeWise + '/NodeUtilization/Days=' + days
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('depName', depName)
      .set('Granularity', granularity)
      .set('UserName', userName)
      .set('Workstation', wsName)
      .set('NodeUsageType', nodeUsageType)
      .set('NodeGroup', nodeGroup)
      .set('ChartName', chartName)
    return this.http.get(baseUrl, { headers: headers });
  }

  getDashboardData(userName: string = '') {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + "SyncGraphData/GetDashoardData";
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set('UserName', userName);
    return this.http.get(baseUrl, { headers: headers });
  }

  getCpuUtilizationAverage() {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/GetCpuUtilizationAverage';
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobCountData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobData/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
    .set('Cache-Control', 'no-cache')
    .set('depName', depName).set('checkUserDepAccess', depName)
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobByApplicationData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByApplication/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getCoresByApplicationData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetCoresByApplication/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getCoreHoursByUsersData(depName: string, period: string, userNames: string = "") {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetCoreHoursByUsers/"+ userNames +"/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName);
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobByNodesData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByNodesForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobByNodeGroupData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByNodeGroupForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobWaitTimeData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobWaitTimeDataForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getNodeAvailabilityData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetNodeAvailabilityDataForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity);
    return this.http.get(baseUrl, { headers: headers });
  }

  getByUserData(depName: string, period: string, granularity, userNames) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByUserDataForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
      .set("UserNames", userNames)
    return this.http.get(baseUrl, { headers: headers });
  }

  getByGroupData(depName: string, period: string, granularity, groupNames) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByUserGroupsDataForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
      .set("GroupNames", groupNames)
    return this.http.get(baseUrl, { headers: headers });
  }

  getPrimeNonPrimeCoresHoursData(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetPrimeNonPrimeData/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
    return this.http.get(baseUrl, { headers: headers });
  }
  //! getJobsByUserByDay----------------------------------------
  getJobsByUserByDay(depName: string, period: string, granularity, userName) {
    let baseUrl =
    this.env.envVariables.httpProtocol +
    this.env.envVariables.webHost +
    "SyncGraphData/Deployment/" +
    depName +
    "/GetJobsByUserByDay/Period/" +
    period;
    let headers = new HttpHeaders();
    headers = headers
    .set("Content-Type", "application/json; charset=utf-8")
    .set("Cache-Control", "no-cache")
    .set("depName", depName)
    .set("Username",userName)
    .set("Granularity", granularity)
    return this.http.get(baseUrl, { headers: headers });
  }
  //! getJobsByUserByDay ENDED----------------------------------------
  
  getJobTagData(depName: string, period: string, granularity, userNames) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByTagsDataForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
      .set("UserNames", userNames)
    return this.http.get(baseUrl, { headers: headers });
  }

  getActiveSessionsPerDep(depName, days, granularity) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/GetActiveSessionsPerDep/Days=' + days
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('Granularity', granularity)
    return this.http.get(baseUrl, { headers: headers });
  }

  uploadReportsFile(fileType: string, myFile: File, days, message) {
    try {
      const formData = new FormData();
      formData.append('File', myFile);

      let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `SyncGraphData/ReportsFile/Upload`;
      let headers = new HttpHeaders();
      headers = headers
        .set('Cache-Control', 'no-cache')
        .set("Access-Control-Allow-Origin", "*")
        .set("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept")
        .set('Days', days)
        .set('Message', message)

      const upload$ = this.http.post<any>(baseUrl, formData, {
        headers: headers,
        reportProgress: true,
        observe: 'events'
      }).pipe();

      return upload$;
    }
    catch (Error) {
    }
  }

  getCoreHoursByGroupsData(depName: string, period: string, groupNames: string = "") {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetCoreHoursByGroups/" + groupNames + "/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName);
    return this.http.get(baseUrl, { headers: headers });
  }

  getSessionDataPerUser(user, type, days, depName) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `ActionLogs/User/${user}/GetSessionLogsPerUser/${type}/Days=${days}/Deployment/${depName}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.get(baseUrl, { headers: headers });
  }

  getSessionDataPerHost(host, type, days, depName) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `ActionLogs/Host/${host}/GetSessionLogsPerUser/${type}/Days=${days}/Deployment/${depName}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.get(baseUrl, { headers: headers });
  }

  getNodeStatusGraphService(host, type, days, depName) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + `SyncGraphData/NodeStatus/GetNodeStatus/Days=${days}/Deployment/${depName}`;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.get(baseUrl, { headers: headers });
  }

  getHpcUnitsConsumed(depName, chartName, days, granularity, userName: string = "all") {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/GetData/Days=' + days + '/HpcUnitsConsumed'
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('depName', depName)
      .set('Granularity', granularity)
      .set('UserName', userName)
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobSessionsForPeriod(days, userName: string = "all") {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/GetJobsSessionForPeriod/Days=' + days;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('UserName', userName)
    return this.http.get(baseUrl, { headers: headers });
  }

  getLicenseUsage(): Observable<any> {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/GetLicenseUsage';
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.get(baseUrl, { headers: headers });
  }

  getAvgJobDurationsByDayService(depName,days, granularity) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/GetAvgJobDurationsByDayDataForDeployment/Period/' + days;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('depName', depName)
      .set('Granularity', granularity)
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobByTagsPerDayData(depName: string, period: string, granularity, userNames) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobByTagsPerDayDataForDeployment/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
      .set("UserNames", userNames)
    return this.http.get(baseUrl, { headers: headers });
  }

  getRunningAndQueuedJobs(depName: string, period: string, granularity) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobCountPerPartition/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
    return this.http.get(baseUrl, { headers: headers });
  }

  getPrimeNonPrimeJobCount(depName: string, period: string, granularity: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetPrimeNonPrimeJobCount/Period/" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("depName", depName)
      .set("Granularity", granularity)
    return this.http.get(baseUrl, { headers: headers });
    }

  getCpuUsage(depName, days, isCpuUsageByNodes: boolean = true, userName: string = "all",) {
      let byNodes = "true";
      if(!isCpuUsageByNodes) {
        byNodes = "false"
      }
      let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/CpuUsage/Days=' + days
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/json; charset=utf-8')
        .set('Cache-Control', 'no-cache')
        .set('depName', depName)
        .set('UserName', userName)
        .set('IsCpuUsageByNodes', byNodes)
      return this.http.get(baseUrl, { headers: headers });
  }

  getCoreUsage(depName, days, isCpuUsageByNodes: boolean = true, userName: string = "all",) {
    let byNodes = "true";
    if(!isCpuUsageByNodes) {
      byNodes = "false"
    }
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/CoreUsage/Days=' + days
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('depName', depName)
      .set('UserName', userName)
      .set('IsCpuUsageByNodes', byNodes)
    return this.http.get(baseUrl, { headers: headers });
  }

  getJobRunQueueDurationAsCSV(
    depName: string,
    period: string,
    chartName: string,
    controlKey: string
  ): Observable<any> { 
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncGraphData/Deployment/" +
      depName +
      "/GetJobRunQueueDurationCSV/Period=" +
      period;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("QueryKey", controlKey);
    return this.http
      .get(baseUrl, { headers: headers, responseType: "blob" })
      .pipe(
        tap((blob) => {
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = `${chartName}.csv`;
          anchor.click();
          window.URL.revokeObjectURL(url);
        })
      );
  }

  getNetworkUsage(depName, chartName, days, granularity, userName: string = "all", wsName: string, nodeWise: boolean, nodeGroup: string, type?: string) {
    let nodeUsageType;
    if (!type && type == null) {
      nodeUsageType = "all";
    }
    else {
      nodeUsageType = type;
    }
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'SyncGraphData/Deployment/' + depName + '/GetData/NodeWise/' + nodeWise + '/NetworkUtilization/Days=' + days
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('depName', depName)
      .set('Granularity', granularity)
      .set('UserName', userName)
      .set('Workstation', wsName)
      .set('NodeUsageType', nodeUsageType)
      .set('NodeGroup', nodeGroup)
      .set('ChartName', chartName)
    return this.http.get(baseUrl, { headers: headers });
  }
  getAvailableDynamicControlsData(LoggedInUser: string, deployment: string = "all"): Observable<DynamicControl[]> {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + "SyncGraphData/GetDynamicControlsData";
    let headers = new HttpHeaders();
    headers = headers.set("UserId", LoggedInUser)
    headers = headers.set("Deployment", deployment);
    return this.http.get<DynamicControl[]>(baseUrl, { headers: headers })
      .pipe(
        map(response => response as DynamicControl[]), // Explicit type assertion
        catchError(error => {
          console.error('Error fetching dynamic controls:', error);
          return of([]); // Return empty array on error
        })
      );  }
}
